import React from 'react';

import { StyledLoader } from '../../styledComponents';

export const Loader = () => (
    <StyledLoader>
        <div className="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </StyledLoader>
);